(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('ApiTokens', ApiTokens);

    ApiTokens.$inject = ['$resource'];

    function ApiTokens ($resource) {
        return $resource('api/account/api-tokens/:id', {}, {
            'getAll': { method: 'GET', isArray: true },
            'create': { method: 'POST' }
        });
    }
})();
